<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <label style="font-weight: 500; font-size: 30px;">
      <p>Hiện tại chúng tôi đang trong quá trình thử nghiệm.</p>
      <p>
      Vui lòng liên hệ SĐT <label style="color: rgb(34,106,226)">0868680661</label> (Huỳnh Võ Nhật Huy) để biết thêm thông tin
      </p>
    </label>
  </div>
  <!--
  <div class="clearfix">
    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      label-placeholder="Họ tên"
      name="displayName"
      placeholder="Họ tên"
      v-model="displayName"
      class="w-full" />
    <span class="text-danger text-sm">{{ errors.first('displayName') }}</span>

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="Email"
      placeholder="Email"
      v-model="email"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
      v-validate="'required|min:10|max:10'"
      data-vv-validate-on="blur"
      label-placeholder="Điện thoại (Tài khoản đăng nhập)"
      name="phone"
      placeholder="Điện thoại"
      v-model="phone"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('phone') }}</span>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:4'"
      name="password"
      label-placeholder="Password"
      placeholder="Password"
      v-model="password"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>


    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      label-placeholder="Tên công ty"
      name="companyName"
      placeholder="Tên công ty"
      v-model="companyName"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('companyName') }}</span>

    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      label-placeholder="Mã số thuế"
      name="mst"
      placeholder="Mã số thuế"
      v-model="mst"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('mst') }}</span>

    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      label-placeholder="Số tài khoản"
      name="bankAccount"
      placeholder="Số tài khoản"
      v-model="bankAccount"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('bankAccount') }}</span>

    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      label-placeholder="Ngân hàng"
      name="bankName"
      placeholder="Ngân hàng"
      v-model="bankName"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('bankName') }}</span>

    <vs-input
      v-validate="'required'"
      data-vv-validate-on="blur"
      label-placeholder="Tên chủ tài khoản"
      name="bankOwner"
      placeholder="Tên chủ tài khoản"
      v-model="bankOwner"
      class="w-full mt-10" />
    <span class="text-danger text-sm">{{ errors.first('bankOwner') }}</span>

    <div class="mb-5 mt-6">
    <v-select
      :clearable="false"
      class="border-none w-full"
      :placeholder="`Chọn Tỉnh/tp`"
      v-model="province"
      name="province"
      :options="$store.state.moduleProduct.provinces"
      :reduce="(p) => p.id"
      label="name"
      :data-vv-as="'Tỉnh/tp'"
    />
    <span class="text-danger text-sm break-normal" v-show="errors.has('province')">{{ errors.first("province") }}</span>
  </div>
  <div class="mb-5 mt-6">
    <v-select
      :clearable="false"
      class="border-none w-full"
      :placeholder="`Chọn Quận/huyện`"
      v-model="district"
      name="district"
      :options="districts"
      :reduce="(p) => p.id"
      label="name"
      :data-vv-as="'Quận/huyện'"
    />
    <span class="text-danger text-sm break-normal" v-show="errors.has('district')">{{ errors.first("district") }}</span>
  </div>
  <div class="mb-5 mt-6">
    <cbs-input v-model="address" class="w-full" name="address" :data-vv-as="'Tên đường'" :placeholder="`${$t('Input')} ${'Tên đường'}`" />
    <span class="text-danger text-sm break-normal" v-show="errors.has('address')">{{ errors.first("address") }}</span>
  </div>

    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">Tôi đồng ý với các điều khoản và chính sách.</vs-checkbox>
    <vs-button  type="border" to="/pages/login" class="mt-6 mb-6">Đăng nhập</vs-button>
    <vs-button class="float-right mt-6" @click="registerUserJWt" :disabled="!validateForm">Đăng ký</vs-button>
  </div>-->
</template>

<script>
import vSelect from "vue-select";
export default {
	components: { vSelect },
    data() {
        return {
          address: '',
          districts: [],
          companyName: '',
          bankAccount: '',
          bankName: '',
          bankOwner: '',
          province: null,
          district: null,
          mst: '',
            displayName: '',
            email: '',
            phone: '',
            password: '',
            confirm_password: '',
            isTermsConditionAccepted: true
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.displayName != '' && this.email != '' && this.password != '' && this.phone != '' && this.isTermsConditionAccepted === true;
        }
    },
	created() {
		this.getProvinces();
	},
  watch: {

		province() {
			if (this.province) {
				this.getDistricts();
			}
		},
  },
    methods: {
      getProvinces() {
        // this.$vs.loading();
        try {
          let payload = {
          };
          this.$store.dispatch("moduleProduct/getProvinces", payload);
          // this.getGetUsers();
          // this.$vs.loading.close();
        } catch (error) {
          console.log(error.message);
          // this.$vs.loading.close();
        }
      },
      getDistricts() {
        // this.$vs.loading();
        try {
          let payload = {
          };
          this.$store.dispatch("moduleProduct/getDistricts", this.province).then(response => {
            this.districts = response ? response : [];
          });
          // this.$vs.loading.close();
        } catch (error) {
          console.log(error.message);
          // this.$vs.loading.close();
        }
      },
        checkLogin() {
          // If user is already logged in notify
          if(this.$store.state.auth.isUserLoggedIn()) {

            // Close animation if passed as payload
            // this.$vs.loading.close()

            this.$vs.notify({
              title: 'Login Attempt',
              text: 'You are already logged in!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
          return true
        },
        registerUserJWt() {
            // If form is not validated or user is already login return
            if (!this.validateForm || !this.checkLogin()) return

            const payload = {
              fullname: this.displayName,
              email: this.email,
              password: this.password,
              confirmPassword: this.password,
              phone: this.phone,
              mst: this.mst,
              companyName: this.companyName,
              bankAccount: this.bankAccount,
              bankName: this.bankName,
              bankOwner: this.bankOwner,
              province: this.province,
              district: this.district,
              address: this.address,
              notify: this.$vs.notify
            }
            this.$store.dispatch('auth/registerUserJWT', payload).then(response => {
              if (response.data && response.data.error) {
                this.$vs.notify({
                  title: 'Login Attempt',
                  text: response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning'
                });
              }
            })
        }
    }
}
</script>
